export interface MediaItem {
  id: string;
  src: string;
  alt: string;
  type: 'image' | 'video';
  thumbnail?: string;
}

export interface ProductMediaConfig {
  [productId: string]: MediaItem[];
}

// Sample media configuration - replace with your actual product images/videos
export const productMediaConfig: ProductMediaConfig = {
  'stryd-pod': [
    {
      id: 'stryd-pod-demo-1',
      src: '/images/stryd5/exploded.mp4',
      alt: 'Stryd Pod Demo Video',
      type: 'video',
      thumbnail: '/images/stryd5/Still 7A.png',
    },
    {
      id: 'stryd-pod-main-1',
      src: '/images/stryd5/Still 3C-2.png',
      alt: 'Stryd Pod - Main View',
      type: 'image',
      thumbnail: '/images/stryd5/Still 3C-2.png',
    },
    {
      id: 'stryd-pod-app-1',
      src: '/images/stryd5/Still 3A-3.png',
      alt: 'Stryd App Interface',
      type: 'image',
      thumbnail: '/images/stryd5/Still 3A-3.png',
    },
    {
      id: 'stryd-pod-features-1',
      src: '/images/stryd5/Still 5B - ON.png',
      alt: 'Stryd Pod Features',
      type: 'image',
      thumbnail: '/images/stryd5/Still 5B - ON.png',
    },
    {
      id: 'stryd-pod-features2-1',
      src: '/images/stryd5/Still 4A-Single.png',
      alt: 'Stryd Pod Features',
      type: 'image',
      thumbnail: '/images/stryd5/Still 4A-Single.png',
    },
  ],
  'stryd-duo': [
    {
      id: 'stryd-pod-demo-2',
      src: '/images/stryd5/Still 2A.png',
      alt: 'Stryd Pod Demo Video',
      type: 'image',
      thumbnail: '/images/stryd5/Still 2A.png',
    },
    {
      id: 'stryd-duo-main-2',
      src: '/images/stryd5/Still 2B.png',
      alt: 'Stryd Duo - Main View',
      type: 'image',
      thumbnail: '/images/stryd5/Still 2B.png',
    },
    {
      id: 'stryd-duo-pair-2',
      src: '/images/stryd5/charging.mp4',
      alt: 'Stryd Duo Pair',
      type: 'video',
      thumbnail: '/images/stryd5/Still 6.png',
    },
    {
      id: 'stryd-duo-sync-2',
      src: '/images/stryd5/Still 5A.png',
      alt: 'Stryd Duo Sync Demo',
      type: 'image',
      thumbnail: '/images/stryd5/Still 5A.png',
    },
    {
      id: 'stryd-duo-features-2',
      src: '/images/stryd5/Still 4A.png',
      alt: 'Stryd Duo Features',
      type: 'image',
      thumbnail: '/images/stryd5/Still 4A.png',
    },
  ],
};

export const getProductMedia = (productId: string): MediaItem[] => {
  return productMediaConfig[productId] || [];
};
